import React from "react";

import { iAddHabitIconCard } from "../types";

export const AddHabitIconCard: React.FC<iAddHabitIconCard> = ({
  IconName,
  title,
}) => {
  return (
    <div className="flex flex-col justify-center  items-center">
      <div
        style={{ width: "55px", height: "55px" }}
        className="flex justify-center  items-center rounded-full "
      >
        <p className="text-5xl text-site-blue-dark "> {IconName}</p>
      </div>
      <div className="pt-3 ">
        <h3 className="text-site-blue-dark">{title}</h3>
      </div>
    </div>
  );
};
